/**
 * CSRF protection utilities
 */

/**
 * Generate a CSRF token
 * @returns {string} - Random CSRF token
 */
export const generateCSRFToken = () => {
  const array = new Uint8Array(32);
  crypto.getRandomValues(array);
  return Array.from(array, byte => byte.toString(16).padStart(2, '0')).join('');
};

/**
 * Get CSRF token from localStorage or generate new one
 * @returns {string} - CSRF token
 */
export const getCSRFToken = () => {
  let token = localStorage.getItem('csrf-token');
  if (!token) {
    token = generateCSRFToken();
    localStorage.setItem('csrf-token', token);
  }
  return token;
};

/**
 * Add CSRF token to request headers
 * @param {Object} headers - Existing headers object
 * @returns {Object} - Headers with CSRF token
 */
export const addCSRFToken = (headers = {}) => {
  return {
    ...headers,
    'X-CSRF-Token': getCSRFToken(),
    'Content-Type': 'application/json',
  };
};

/**
 * Validate CSRF token in response
 * @param {Response} response - Fetch response
 * @returns {boolean} - True if token is valid
 */
export const validateCSRFToken = (response) => {
  const serverToken = response.headers.get('X-CSRF-Token');
  const clientToken = getCSRFToken();
  
  if (serverToken && serverToken !== clientToken) {
    // Token mismatch - clear and regenerate
    localStorage.removeItem('csrf-token');
    return false;
  }
  
  return true;
}; 